// import { Link } from 'react-router-dom';
// import riwaazImage from '../../assets/images/events/riwaaz/riwaaz.png';
// import yplix from '../../assets/images/yplix/yplix.jpeg';
// import './Events.css';

// const Events = () => {
//   return (
//     <div className="events-page py-4">
//       <div className="container py-3">
//         <div className="row justify-content-center">
//           <div className="col-lg-10">

//             <div className="banner-card overflow-hidden">

//               <div className="text-center p-4 pb-0">
//                 <img
//                   src={riwaazImage}
//                   alt="Riwaaz - The Culture of India"
//                   className="img-fluid banner-image"
//                 />
//               </div>

//               <div className="card-body p-4 p-lg-4 text-white">

//                 <div className="text-center mb-4">
//                   <span className="badge event-badge px-3 py-2 rounded-pill">
//                     Reality Show 2026
//                   </span>

//                   <h2 className="display-6 fw-bold mt-3 mb-2">
//                     HOUSE X²
//                   </h2>

//                   <p className="lead text-warning fw-semibold mb-0">
//                     Bharat Ki Sanskriti Ka MahaKumbh
//                   </p>
//                 </div>

//                 <p className="text-white-50 fs-5">
//                   <strong className="text-white">
//                     Riwaaz – The Culture of India
//                   </strong>{' '}
//                   is a grand cultural reality show dedicated to discovering,
//                   celebrating, and promoting talented individuals from every
//                   corner of India.
//                 </p>

//                 <p className="text-white-50 fs-5">
//                   This unique platform brings together contestants from across
//                   the country to showcase India's rich heritage through
//                   traditional costumes, fashion, dance, music, art, and cultural
//                   performances.
//                 </p>

//                 <p className="text-white-50 fs-5 mb-5">
//                   Experience India's vibrant traditions on one national stage,
//                   where talent meets culture and diversity becomes the true
//                   celebration of our nation.
//                 </p>

//                 <div className="row g-4 mb-5">

//                   <div className="col-md-4">
//                     <div className="info-box h-100 text-center p-4 rounded-4">
//                       <div className="fs-1 mb-2">📍</div>
//                       <h6 className="fw-bold text-warning">Venue</h6>
//                       <p className="mb-0 text-white-50">
//                         Goa, India
//                       </p>
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="info-box h-100 text-center p-4 rounded-4">
//                       <div className="fs-1 mb-2">🎥</div>
//                       <h6 className="fw-bold text-warning">
//                         Shoot Location
//                       </h6>
//                       <p className="mb-0 text-white-50">
//                         Goa
//                       </p>
//                     </div>
//                   </div>

//                   <div className="col-md-4">
//                     <div className="info-box h-100 text-center p-4 rounded-4">
//                       <img
//                         src={yplix}
//                         alt="YPix OTT"
//                         className="img-fluid yplix-logo mb-3"
//                       />

//                       <h6 className="fw-bold text-warning mb-2">
//                         Streaming Partner
//                       </h6>

//                       <p className="mb-1 text-white-50">
//                         Exclusively Streaming
//                       </p>
//                     </div>
//                   </div>

//                 </div>

//                 <div className="mb-5">
//                   <h3 className="fw-bold text-warning text-center mb-4">
//                     Show Highlights
//                   </h3>

//                   <div className="row g-3">

//                     {[
//                       'National Level Cultural Reality Show',
//                       'Traditional & Modern Fashion Showcase',
//                       'Dance Performances',
//                       'Music & Singing',
//                       'Art & Creative Talent',
//                       'Contestants from Across India',
//                       "Celebrate India's Heritage & Diversity",
//                       'National OTT Streaming'
//                     ].map((item, index) => (
//                       <div className="col-md-6" key={index}>
//                         <div className="highlight-box rounded-3 p-3 h-100">
//                           ✨ {item}
//                         </div>
//                       </div>
//                     ))}

//                   </div>
//                 </div>

//                 <div className="text-center">
//                   <Link
//                     to="/registration"
//                     className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
//                   >
//                     Register Now
//                   </Link>
//                 </div>

//               </div>

//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Events;



import { Link } from 'react-router-dom';
import riwaazImage from '../../assets/images/events/riwaaz/x2.jpeg';
import './Events.css';

const Events = () => {
  return (
    <div className="events-page py-4">
      <div className="container py-3">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-card overflow-hidden">
              <div className="text-center p-4 pb-0">
                <img
                  src={riwaazImage}
                  alt="HOUSE X²"
                  className="img-fluid banner-image"
                />
              </div>

              <div className="card-body p-4 p-lg-4 text-white">
                <div className="text-center mb-4">
                  <span className="badge event-badge px-3 py-2 rounded-pill">
                    Reality Show 2026
                  </span>

                  <h2 className="display-6 fw-bold mt-3 mb-2">
                    HOUSE X²
                  </h2>

                  <p className="lead text-warning fw-semibold mb-0">
                    Double the House. Double the Challenge.
                  </p>
                </div>

                <p className="text-white-50 fs-5">
                  <strong className="text-white">HOUSE X²</strong> is an
                  original reality competition show by <strong>SRK Production</strong>,
                  where <strong>18–20 contestants</strong> from diverse
                  backgrounds live together in a luxury villa for
                  <strong> 8–10 weeks</strong>, competing in exciting physical,
                  mental, social, and strategic challenges.
                </p>

                <p className="text-white-50 fs-5">
                  Every day brings new opportunities to prove your strength,
                  intelligence, leadership, and personality. Contestants must
                  build alliances, face unexpected twists, complete secret
                  missions, and survive weekly nominations and eliminations to
                  stay in the game.
                </p>

                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    What to Expect
                  </h3>

                  <div className="row g-3">
                    {[
                      '🏡 Live in a luxury villa',
                      '⚡ Daily team & individual challenges',
                      '🎭 Strategy, alliances & entertainment',
                      '🎯 Secret missions and surprise twists',
                      '🏆 Weekly eliminations leading to the Grand Finale',
                      '💰 Win the HOUSE X² Trophy, cash prizes, and opportunities with SRK Production',
                    ].map((item, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    Who Can Apply?
                  </h3>

                  <p className="text-white-50 fs-5 text-center">
                    We are looking for passionate and confident individuals
                    aged <strong className="text-white">18–35</strong>,
                    including:
                  </p>

                  <div className="row g-3">
                    {[
                      'Models',
                      'Influencers',
                      'Entrepreneurs',
                      'Athletes',
                      'Performers',
                      'Content Creators',
                      'Students & Professionals',
                      'Anyone with a unique personality and competitive spirit',
                    ].map((item, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          ✨ {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="text-center mb-5">
                  <h3 className="fw-bold text-warning mb-3">
                    Ready to Enter the House?
                  </h3>

                  <p className="text-white-50 fs-5">
                    If you have the confidence to compete, the intelligence to
                    strategize, and the determination to outlast everyone else,
                    <strong className="text-white"> HOUSE X²</strong> is your
                    chance to prove yourself.
                  </p>

                  <p className="text-white-50 fs-5">
                    Complete the registration form below to begin your journey.
                    Shortlisted applicants will be contacted for the next stage
                    of the selection process.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/registration"
                    className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;